import type { LiliLinkProps } from './LiliLink.types';
import { LiliLinkSize, LiliLinkType } from './LiliLink.types';
import { getLinkClassName } from './styles';
import { useFontClass } from '../../tokens';

export const LiliLink = (props: LiliLinkProps) => {
  const {
    type = LiliLinkType.DEFAULT,
    size = LiliLinkSize.MEDIUM,
    leftIcon,
    rightIcon,
    title,
    className,
    testId,
    ...rest
  } = props;
  const { fontClass } = useFontClass();

  return (
    <span className={getLinkClassName(type, size, fontClass, className)} data-testid={testId}>
      {leftIcon}
      <a {...rest}>{title}</a>
      {rightIcon}
    </span>
  );
};
